import React, { useState, useEffect, useRef } from 'react';
import T from 'prop-types';

import Modal from '../../../Modal';
import Button from '../../../Buttons/Button';
import InputText from '../../../Inputs/InputText';
import { generateDateTimeSuffix, isDateTimeSuffix } from '../../../../utils/helpers';

const SaveExportSettingsModal = ({ open, report, onConfirm, onClose }) => {
  const inputTextRef = useRef();
  // Update name if it has date suffix pattern
  const [name, setName] = useState(
    isDateTimeSuffix(report.name) ? generateDateTimeSuffix() : report.name
  );

  const isUpsertDisabled = !name.trim();

  const handleUpsertExport = (e) => {
    e.preventDefault();
    if (isUpsertDisabled) return;

    onConfirm({ action: 'create', should_redirect: false, one_time: false, name });
    onClose();
  };

  // Effects
  useEffect(() => {
    // Select input text on open
    inputTextRef.current.select();
  }, []);

  return (
    <Modal
      open={open}
      size="xs"
      closeButtonIconClass="hicon-close-2"
      modalClassName="upsert-export-modal"
      onClose={onClose}
    >
      <form onSubmit={handleUpsertExport}>
        <div className="upsert-export-modal__body">
          <h4 className="upsert-export-modal__title">Save Export Settings</h4>
          <small className="upsert-export-modal__description">
            We’re currently generating your export and will notify you when it’s ready. Save your
            Export Settings selections for future use. Note that entity and date ranges are not
            saved.
          </small>

          <div className="upsert-export-modal__form-fields">
            <InputText
              ref={inputTextRef}
              value={name}
              placeholder="Export Name"
              onChange={setName}
            />
          </div>
        </div>

        <div className="upsert-export-modal__footer">
          <Button size="lg" variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button size="lg" disabled={isUpsertDisabled} type="submit">
            Save Export Settings
          </Button>
        </div>
      </form>
    </Modal>
  );
};

SaveExportSettingsModal.propTypes = {
  open: T.bool.isRequired,
  report: T.object.isRequired,
  onConfirm: T.func,
  onClose: T.func.isRequired,
};

export default SaveExportSettingsModal;
